<template>
  <div>
    <h4 v-if="title" class="grey--text">
      {{ $t(`hausefulInvoices.${title}`) }}
    </h4>

    <div v-for="(client, index) in clients" :key="index">
      <h5 class="subtitle-1 grey--text text--darken-2 pl-1">
        <span class="d-block grey--text font-weight-bold caption mt-4 mb-n1">
          {{ $t('hausefulInvoices.realEstate') }}
        </span>
        {{ client.name }}
      </h5>
      <HostInvoiceBranch :branches="client.branches" />
    </div>
  </div>
</template>

<script>
import HostInvoiceBranch from './HostInvoiceBranch'

export default {
  name: 'HostInvoiceFortnight',

  props: {
    fortnight: {
      type: Object,
    },

    title: {
      type: String,
    },
  },

  components: {
    HostInvoiceBranch,
  },

  computed: {
    clients() {
      return Object.values(this.fortnight)
    },
  }
}
</script>
